var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEurope = function SvgEurope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 728.81 494.59"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-218.65 -119.5)scale(1.1457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.46 104.93h634.85v430.43H191.46z",
    style: {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      fill: "#009"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Europe_svg__a",
    d: "m507.83 186.28-13.81-10.36-14.41 10.29 5.59-16.33-14.23-10.53 17.25.27 5.61-16.79 5.09 16.49 17.7.15-14.12 9.93z",
    style: {
      strokeOpacity: 0.20886,
      fillRule: "evenodd",
      stroke: "#e6f32e",
      strokeWidth: "1pt",
      fill: "#fc0"
    },
    transform: "translate(153.72 151.39)"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__a",
    id: "Europe_svg__b",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(-18.714 -69.819)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__b",
    id: "Europe_svg__c",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(-49.665 -50.385)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__c",
    id: "Europe_svg__d",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(-69.819 -19.434)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__d",
    id: "Europe_svg__e",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(-69.099 18.714)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__e",
    id: "Europe_svg__f",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(-51.824 50.385)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__f",
    id: "Europe_svg__g",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(-18.714 69.819)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__g",
    id: "Europe_svg__h",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(18.714 71.259)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__h",
    id: "Europe_svg__i",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(50.385 51.824)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__i",
    id: "Europe_svg__j",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(69.819 18.714)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__j",
    id: "Europe_svg__k",
    width: 1052.362,
    height: 744.094,
    x: 0,
    y: 0,
    transform: "translate(69.819 -18.714)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Europe_svg__k",
    width: 1052.362,
    height: 744.094,
    transform: "translate(51.824 -51.824)"
  }))));
};
export default SvgEurope;